// src/@shared/SideBar.js

import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";

import {
  ShoppingCartOutlined,
  BarChartOutlined,
  FileProtectOutlined,
  ClockCircleOutlined,
  SkinOutlined,
  LineChartOutlined,
  DesktopOutlined,
  ToolOutlined,
  DashboardOutlined,
  SendOutlined,
  SwapOutlined,
  InboxOutlined,
  UploadOutlined,
  DownloadOutlined,
  ShopOutlined,
  FileTextOutlined,
  EyeOutlined,
  SearchOutlined,
  FormOutlined,BookOutlined, SettingOutlined, MailOutlined
} from "@ant-design/icons";

import {
  Layout,
  Menu,
} from "antd";

import {
  useLocation,
  useNavigate,
} from "react-router-dom";




const { Sider } =
  Layout;

const { SubMenu } =
  Menu;

const MOBILE_BREAKPOINT =
  768;

export const sortingMenuByCodeKey = {
  "1": {
    key: "1",
    icon: <FileProtectOutlined />,
    link: "/kanban-plan-sheet",
    label: "Khanban Sorting Sheet",
  },

  "2": {
    key: "2",
    icon: <BarChartOutlined />,
    link: "/supermarket-dashboard",
    label: "Supermarket Dashboard",
  },

  "3": {
    key: "3",
    icon: <ShoppingCartOutlined />,
    link: "/supermarket-inward",
    label: "Supermarket Inward",
  },

  "4": {
    key: "4",
    icon: <ShoppingCartOutlined />,
    link: "/supermarket-outward",
    label: "Supermarket Outward",
  },

  "5": {
    key: "5",
    icon: <ShoppingCartOutlined />,
    link: "/eol-dashboard",
    label: "EOL Dashboard",
  },

  "6": {
    key: "6",
    icon: <ShoppingCartOutlined />,
    link: "/eol-reports",
    label: "EOL Reports",
  },

  "8": {
    key: "8",
    icon: <ShoppingCartOutlined />,
    link: "/hourly-report",
    label: "Hourly Report",
  },

  "9": {
    key: "9",
    label: "Production Monitoring",
    icon: <BarChartOutlined />,
    children: [
      {
        key: "10",
        label: "Time History",
        link: "/critical-operation/time-operation",
        icon: <ClockCircleOutlined />,
      },
      {
        key: "11",
        label: "Garments Production",
        link: "/critical-operation/garment-production",
        icon: <SkinOutlined />,
      },
      {
        key: "12",
        label: "Hourly Production",
        link: "/critical-operation/hourly-production",
        icon: <LineChartOutlined />,
      },
      {
        key: "16",
        label: "Incentive Line Report",
        link: "/critical-operation/incentive-line-report",
        icon: <FileTextOutlined />,
      },
    ],
  },

  "13": {
    key: "13",
    label: "Master Setup",
    icon: <ToolOutlined />,
    children: [
      {
        key: "14",
        label: "Devices",
        link: "/critical-operation/machine-devices",
        icon: <DesktopOutlined />,
      },
      {
        key: "15",
        label: "Critical Operations",
        link: "/critical-operation/operation-master",
        icon: <ToolOutlined />,
      },
    ],
  },

  // ================= EOL DISPATCH =================

  "17": {
    key: "17",
    label: "EOL Dispatch Dashboard",
    link: "/eol-dispatch-dashboard",
    icon: <DashboardOutlined />,
  },

  "18": {
    key: "18",
    label: "EOL Dispatch",
    link: "/eol-dispatch-center",
    icon: <SendOutlined />,
  },

  "19": {
    key: "19",
    label: "Manage Bin",
    link: "/eol-manage-bin",
    icon: <ShopOutlined />,
  },

  // ================= DISPATCH CENTER =================

  "20": {
    key: "20",
    label: "DC Dashboard",
    link: "/dc-dashboard",
    icon: <DashboardOutlined />,
  },

  "21": {
    key: "21",
    label: "DC Bulk Bin Outward",
    link: "/dc-bulk-bin-outward",
    icon: <UploadOutlined />,
  },

  "22": {
    key: "22",
    label: "DC Bin Outward",
    link: "/dc-bin-outward",
    icon: <SendOutlined />,
  },

  // ================= WASHING CENTER =================

  "24": {
    key: "24",
    label: "WC Dashboard",
    link: "/wc-dashboard",
    icon: <DashboardOutlined />,
  },

  "25": {
    key: "25",
    label: "WC Bin In Transit",
    link: "/wc-bin-in-transit",
    icon: <SwapOutlined />,
  },

  "26": {
    key: "26",
    label: "WC Bin Inward",
    link: "/wc-bin-inward",
    icon: <DownloadOutlined />,
  },

  "27": {
    key: "27",
    label: "WC Bin Bulk Inward",
    link: "/wc-bin-bulk-inward",
    icon: <InboxOutlined />,
  },

  "28": {
    key: "28",
    label: "WC Bin Outward",
    link: "/wc-bin-outward",
    icon: <UploadOutlined />,
  },

  "29": {
    key: "29",
    label: "WC Bin Bulk Outward",
    link: "/wc-bin-bulk-outward",
    icon: <SendOutlined />,
  },

  // ================= GARMENT SUPER MARKET =================

  "31": {
    key: "31",
    label: "GSM Dashboard",
    link: "/gsm-dashboard",
    icon: <DashboardOutlined />,
  },

  "32": {
    key: "32",
    label: "GSM In Transit",
    link: "/gsm-in-transit",
    icon: <SwapOutlined />,
  },

  "33": {
    key: "33",
    label: "GSM Bin Inward",
    link: "/gsm-bin-inward",
    icon: <DownloadOutlined />,
  },

  "34": {
    key: "34",
    label: "GSM Bulk Bin Inward",
    link: "/gsm-bulk-bin-inward",
    icon: <InboxOutlined />,
  },

  "35": {
    key: "35",
    label: "GSM Bin Outward",
    link: "/gsm-outward",
    icon: <UploadOutlined />,
  },

  // ================= KANBAN COUNT =================

  "37": {
    key: "37",
    label: "KCN Dashboard",
    link: "/kcn-dashboard",
    icon: <DashboardOutlined />,
  },

  "38": {
    key: "38",
    label: "Sent To Finishing",
    link: "/sent-to-finishing",
    icon: <SendOutlined />,
  },

  // ================= WASHING REPORTS =================

  "39": {
    key: "39",
    label: "Washing Reports",
    icon: <FileTextOutlined />,
    children: [
      {
        key: "40",
        label: "Sewing Out Kanban",
        link: "/active-kanban",
        icon: <BarChartOutlined />,
      },
      {
        key: "41",
        label: "Track Bin",
        link: "/track-bin",
        icon: <SearchOutlined />,
      },
      {
        key: "42",
        label: "Daily Report",
        link: "/daily-report",
        icon: <FileTextOutlined />,
      },
      {
        key: "43",
        label: "View Bin",
        link: "/view-bin",
        icon: <EyeOutlined />,
      },
      {
        key: "44",
        label: "Bin Status",
        link: "/bin-status",
        icon: <BarChartOutlined />,
      },
      {
        key: "45",
        label: "DC Inward / Outward Bin",
        link: "/dc-bin-report",
        icon: <SwapOutlined />,
      },
      {
        key: "46",
        label: "WC Inward / Outward Bin",
        link: "/wc-bin-report",
        icon: <SwapOutlined />,
      },
      {
        key: "47",
        label: "GSM Inward / Outward Bin",
        link: "/gsm-bin-report",
        icon: <SwapOutlined />,
      },
    ],
  },

  // ================= EXAM MANAGEMENT =================

"51": {
  key: "51",
  label: "Exam Management",
  icon: <FormOutlined />,

  children: [
    {
      key: "55",
      label: "Assessment Dashboard",
      link: "/exam-management/dashboard",
      icon: <DashboardOutlined />,
    
    },

    {
      key: "52",
      label: "Upload Exam Excel",
      link: "/exam-management/upload",
      icon: <UploadOutlined />,
    },

    {
      key: "53",
      label: "Manage Exams",
      link: "/exam-management",
      icon: <FileTextOutlined />,
    },

    {
      key: "54",
      label: "Assessment Results",
      link: "/exam-management/results",
      icon: <BarChartOutlined />,
    },
  ],
},

// ================= TRAINING MATERIALS =================

"56": {
  key: "56",
  label: "Training Materials",
  icon: <BookOutlined />,

  children: [
    {
      key: "57",
      label: "Manage Training Material",
      link: "/training-materials/manage",
      icon: <UploadOutlined />,
     
    },
  ],
},

// ================= BACKLOG REPORT =================

"58": {
  key: "58",
  label: "Backlog Report",
  link: "/backlog-report",
   icon: <FileTextOutlined />,
},
// ================= CAPACITY STATUS REPORT =================
"59": {
  key: "59",
  label: "Capacity Status Report",
  link: "/capacity-status-report",
  icon: <BarChartOutlined />,
},
"60": {
  key: "60",
  label: "Capacity Management",
  link: "/capacity-management",
  icon: <BarChartOutlined />,
},
"61": {
  key: "61",
  label: "Item-wise Backlog",
  link: "/Style-wise-backlog",
  icon: <FileTextOutlined />,
},
"62": {
  key: "62",
  label: "Finishing Backlog Dashboard",
  link: "/finishing-backlog-analytics",
  icon: <BarChartOutlined />,
},
// Settings entries remain permission-gated via the navigation API.
// Assign code_key 64 to departments allowed to manage report recipients.
"63": {
  key: "63",
  label: "Settings",
  icon: <SettingOutlined />,
  children: [
    {
      key: "64",
      label: "Manage Mail",
      link: "/settings/manage-mail",
      icon: <MailOutlined />,
    },
  ],
},
};

export const getRouteByCodeKey = (codeKey) => {
  const key = String(codeKey);

  for (const item of Object.values(sortingMenuByCodeKey)) {
    if (String(item.key) === key && item.link) {
      return item.link;
    }

    if (Array.isArray(item.children)) {
      const child = item.children.find(
        (subItem) => String(subItem.key) === key
      );

      if (child?.link) {
        return child.link;
      }
    }
  }

  return null;
};

const Sidebar = ({
  collapsed,
  userData,
  toggleSidebar,
}) => {
  const location =
    useLocation();

  const navigate =
    useNavigate();

  const [
    selectedKey,
    setSelectedKey,
  ] =
    useState();

  const [
    openKeys,
    setOpenKeys,
  ] =
    useState([]);

  const [
    lastOpenKeys,
    setLastOpenKeys,
  ] =
    useState([]);

  const [
    sortingNavApiItems,
    setSortingNavApiItems,
  ] =
    useState([]);

  const [
    navLoading,
    setNavLoading,
  ] =
    useState(true);

  const [
    navCheckedOnce,
    setNavCheckedOnce,
  ] =
    useState(false);

  const [
    navMessage,
    setNavMessage,
  ] =
    useState("");

  const [
    isMobile,
    setIsMobile,
  ] =
    useState(
      typeof window !==
        "undefined"
        ? window.innerWidth <=
            MOBILE_BREAKPOINT
        : false
    );

  const notAllowedRedirectDone =
    useRef(false);

  // ============================================================
  // RESPONSIVE
  // ============================================================

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(
        window.innerWidth <=
          MOBILE_BREAKPOINT
      );
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  // ============================================================
  // NAVIGATION API
  // ============================================================

  useEffect(() => {
    if (!userData) {
      return;
    }

    const deptIds =
      userData.dept_ids ||
      userData.dept;

    if (!deptIds) {
      setSortingNavApiItems(
        []
      );

      setNavMessage(
        "Department not found for this user."
      );

      setNavLoading(
        false
      );

      setNavCheckedOnce(
        true
      );

      return;
    }

    setNavLoading(
      true
    );

    setNavMessage(
      ""
    );

    const baseURL =
      "https://portals.smartekanban.in/";

    const url =
      `${baseURL}index.php/Apiv1/get_navigation_by_dept_ids`;

    const formData =
      new FormData();

    formData.append(
      "dept_id",
      deptIds
    );

    fetch(
      url,
      {
        method:
          "POST",
        body:
          formData,
      }
    )
      .then(
        (res) =>
          res.json()
      )
      .then(
        (res) => {
          if (
            res?.status &&
            Array.isArray(
              res?.data
            )
          ) {
            setSortingNavApiItems(
              res.data
            );

            if (
              res.data.length ===
              0
            ) {
              setNavMessage(
                "No navigation is assigned for your department."
              );
            }
          } else {
            setSortingNavApiItems(
              []
            );

            setNavMessage(
              res?.message ||
              "Navigation not found / not allowed."
            );
          }
        }
      )
      .catch(
        (err) => {
          console.error(
            "Navigation API failed",
            err
          );

          setSortingNavApiItems(
            []
          );

          setNavMessage(
            "Navigation API failed. Please contact admin."
          );
        }
      )
      .finally(
        () => {
          setNavLoading(
            false
          );

          setNavCheckedOnce(
            true
          );
        }
      );
  }, [userData]);

  // ============================================================
  // MENU ITEMS
  // ============================================================

  const itemsToRender =
    useMemo(
      () => {
        if (!userData) {
          return [];
        }

        const apiKeys =
          new Set(
            (
              sortingNavApiItems ||
              []
            )
              .map(
                (x) =>
                  String(
                    x.code_key
                  )
              )
              .filter(
                Boolean
              )
          );

        const merged =
          [];

        Object.entries(
          sortingMenuByCodeKey
        ).forEach(
          ([
            codeKey,
            cfg,
          ]) => {
            if (
              !cfg.children
            ) {
              const shouldShow =
                cfg.flag ===
                  1 ||
                apiKeys.has(
                  String(
                    codeKey
                  )
                );

              if (
                shouldShow
              ) {
                merged.push(
                  {
                    ...cfg,
                    __codeKey:
                      String(
                        codeKey
                      ),
                  }
                );
              }

              return;
            }

            const allowedChildren =
              cfg.children.filter(
                (c) =>
                  c.flag ===
                    1 ||
                  apiKeys.has(
                    String(
                      c.key
                    )
                  )
              );

            if (
              allowedChildren.length >
              0
            ) {
              merged.push(
                {
                  ...cfg,
                  children:
                    allowedChildren,
                  __codeKey:
                    String(
                      codeKey
                    ),
                }
              );
            }
          }
        );

        merged.sort(
          (
            a,
            b
          ) =>
            Number(
              a.__codeKey ??
                a.key ??
                9999
            ) -
            Number(
              b.__codeKey ??
                b.key ??
                9999
            )
        );

        return merged;
      },
      [
        sortingNavApiItems,
        userData,
      ]
    );

  // ============================================================
  // NO ACCESS
  // ============================================================

  useEffect(() => {
    if (!userData) {
      return;
    }

    if (
      !navCheckedOnce ||
      navLoading
    ) {
      return;
    }

    if (
      itemsToRender.length ===
      0
    ) {
      const reasonMsg =
        navMessage ||
        "You are not allowed to access any modules.";

      if (
        !notAllowedRedirectDone.current
      ) {
        notAllowedRedirectDone.current =
          true;

        localStorage.setItem(
          "nav_message",
          reasonMsg
        );

        navigate(
          "/user-not-allow",
          {
            replace:
              true,
          }
        );
      }
    }
  }, [
    itemsToRender,
    userData,
    navLoading,
    navCheckedOnce,
    navMessage,
    navigate,
  ]);

  // ============================================================
  // SELECT CURRENT ROUTE
  //
  // IMPORTANT:
  // No automatic "first menu" redirect.
  // ============================================================

  useEffect(() => {
    if (
      !itemsToRender.length
    ) {
      return;
    }

    let matchedKey;
    let matchedParentKey;

    const currentPath =
      location.pathname;

    for (
      const item of
      itemsToRender
    ) {
      if (
        item.children
      ) {
        // Longest route first.
        // This prevents "/exam-management"
        // matching before "/exam-management/results".

        const children =
          [
            ...item.children,
          ].sort(
            (
              a,
              b
            ) =>
              String(
                b.link || ""
              ).length -
              String(
                a.link || ""
              ).length
          );

        const child =
          children.find(
            (c) =>
              currentPath ===
                c.link ||
              currentPath.startsWith(
                `${c.link}/`
              )
          );

        if (child) {
          matchedKey =
            child.key;

          matchedParentKey =
            item.key;

          break;
        }
      }

      if (
        item.link &&
        (
          currentPath ===
            item.link ||
          currentPath.startsWith(
            `${item.link}/`
          )
        )
      ) {
        matchedKey =
          item.key;

        break;
      }
    }

    if (
      matchedKey
    ) {
      setSelectedKey(
        matchedKey
      );
    }

    if (
      matchedParentKey
    ) {
      setLastOpenKeys(
        [
          matchedParentKey,
        ]
      );

      if (
        !collapsed
      ) {
        setOpenKeys(
          [
            matchedParentKey,
          ]
        );
      }
    }
  }, [
    location.pathname,
    itemsToRender,
    collapsed,
  ]);

  useEffect(() => {
    if (
      !collapsed
    ) {
      setOpenKeys(
        lastOpenKeys
      );
    }
  }, [
    collapsed,
    lastOpenKeys,
  ]);

  // ============================================================
  // MOBILE MENU CLICK
  // ============================================================

  const handleMenuClick =
    (e) => {
      const route =
        getRouteByCodeKey(
          e.key
        );

      setSelectedKey(
        e.key
      );

      if (
        route &&
        route !== location.pathname
      ) {
        navigate(
          route
        );
      }

      if (
        isMobile &&
        !collapsed
      ) {
        toggleSidebar?.();
      }
    };

  return (
    <>
{isMobile &&
        !collapsed && (
          <div
            role="button"
            tabIndex={0}
            aria-label="Close sidebar"
            className="smartapp-sidebar-backdrop"
            onClick={() => toggleSidebar?.()}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                toggleSidebar?.();
              }
            }}
          />
        )}

      <Sider
        className={collapsed ? "smartapp-sidebar is-collapsed" : "smartapp-sidebar is-expanded"}
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={248}
        collapsedWidth={isMobile ? 0 : 76}
      >
        <div
          className={
            collapsed
              ? "smartapp-sidebar-brand is-collapsed"
              : "smartapp-sidebar-brand"
          }
        >
          <img
            src="/logo192.png"
            alt="SM-ART"
            className="smartapp-sidebar-brand-logo"
          />
        </div>

        <Menu
          theme="dark"
          mode="inline"
          inlineCollapsed={
            collapsed
          }
          triggerSubMenuAction="click"
          selectedKeys={
            selectedKey
              ? [
                  selectedKey,
                ]
              : []
          }
          openKeys={
            collapsed
              ? undefined
              : openKeys
          }
          onOpenChange={(
            keys
          ) => {
            if (
              !collapsed
            ) {
              setOpenKeys(
                keys
              );

              setLastOpenKeys(
                keys
              );
            }
          }}
          onClick={handleMenuClick}
          className="smartapp-sidebar-menu smartapp-sidebar-menu-modern"
        >
          {itemsToRender.map(
            (item) => {
              if (
                item.children
              ) {
                return (
                  <SubMenu
                    key={
                      item.key
                    }
                    icon={
                      item.icon
                    }
                    title={
                      item.label
                    }
                  >
                    {item.children.map(
                      (
                        sub
                      ) => (
                        <Menu.Item
                          key={
                            sub.key
                          }
                          icon={
                            sub.icon
                          }
                        >
                          {
                            sub.label
                          }
                        </Menu.Item>
                      )
                    )}
                  </SubMenu>
                );
              }

              return (
                <Menu.Item
                  key={
                    item.key
                  }
                  icon={
                    item.icon
                  }
                >
                  {
                    item.label
                  }
                </Menu.Item>
              );
            }
          )}
        </Menu>
      </Sider>
    </>
  );
};

export default Sidebar;
